// extracted by mini-css-extract-plugin
export default {"audio-container":"recordingPanel_audio-container__kubad","audio-bar":"recordingPanel_audio-bar__4DFio"};